var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stats.status !== false)?_c('div',{staticClass:"TxProductStats",domProps:{"innerHTML":_vm._s(_vm.stats.stats_html)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }